import React, { InputHTMLAttributes } from 'react'

interface SpaceProps extends InputHTMLAttributes<HTMLDivElement> {
  size: number
  direction?: 'horizontal' | 'vertical'
}

export const Space: React.FC<SpaceProps> = ({ size, direction = 'vertical', ...other }) => {
  const style = direction === 'horizontal' ? { width: `${size}px` } : { height: `${size}px` }

  return <div style={style} {...other} />
}
